import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { CONTACT } from "@/data/site";

export default function FloatingActions() {
  return (
    <>
      {/* Desktop floating buttons */}
      <div className="fixed bottom-6 right-6 z-40 hidden flex-col gap-3 md:flex">
        <motion.a
          href={CONTACT.whatsapp}
          target="_blank"
          rel="noreferrer"
          data-testid="float-whatsapp"
          aria-label="Chat on WhatsApp"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.6, type: "spring", stiffness: 200 }}
          whileHover={{ scale: 1.08 }}
          className="grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.6)]"
        >
          <MessageCircle className="h-6 w-6" />
        </motion.a>
        <motion.a
          href={`tel:${CONTACT.phoneRaw}`}
          data-testid="float-call"
          aria-label="Call us"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.7, type: "spring", stiffness: 200 }}
          whileHover={{ scale: 1.08 }}
          className="grid h-14 w-14 place-items-center rounded-full bg-dq-ink text-white shadow-lg"
        >
          <Phone className="h-5 w-5" />
        </motion.a>
      </div>

      {/* Mobile sticky bottom bar */}
      <div
        data-testid="mobile-bottom-bar"
        className="glass fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 gap-2 border-t border-white/40 p-3 md:hidden"
      >
        <a href={`tel:${CONTACT.phoneRaw}`} data-testid="bottom-call"
           className="flex flex-col items-center gap-1 rounded-2xl py-1.5 text-xs font-semibold text-dq-ink">
          <Phone className="h-5 w-5 text-dq-orange" /> Call
        </a>
        <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="bottom-whatsapp"
           className="flex flex-col items-center gap-1 rounded-2xl py-1.5 text-xs font-semibold text-dq-ink">
          <MessageCircle className="h-5 w-5 text-[#25D366]" /> WhatsApp
        </a>
        <Link to="/contact" data-testid="bottom-consult"
           className="flex flex-col items-center gap-1 rounded-2xl bg-dq-orange py-1.5 text-xs font-semibold text-white">
          <CalendarCheck className="h-5 w-5" /> Consult
        </Link>
      </div>
    </>
  );
}
